import React, { Component } from 'react';
// import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import { Row, Col } from 'react-bootstrap';
import PhotoContainer from '../PhotoContainer';
import CreateMember from './CreateMember';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';

class NewMember extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openCreateModal: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { status } = nextProps;

    if (this.props.status === actionTypes.MEMBER_CREATE_REQUEST) {
      if (status === actionTypes.MEMBER_CREATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    }
  }

  onClick(e) {
    e.preventDefault();

    this.setState({ openCreateModal: true });
  }

  handleCloseModal() {
    this.setState({ openCreateModal: false });
  }

  handleCreateMember(data) {
    const { team } = this.props;

    this.props.hideAlert();

    if (team) {
      const member = {
        team: team.id,
        member: { ...data, full_name: data.name },
      };
      this.props.createMember(member);
    } else {
      const member = {
        user_info: {
          email: data.email,
          name: data.name,
          avatar: data.avatar,
          company_name: data.company_name,
          user_title: data.user_title,
          use_company_name: data.use_company_name,
        },
        role_ids: data.role_ids,
        ownership_type_id: data.ownership_type_id,
      };
      this.props.addMember(member);
    }
  }

  render() {
    return (
      <div className="member new-member" onClick={(e) => this.onClick(e)}>
        <Row>
          <Col md={3} className="member-photo">
            <PhotoContainer className="photo-container">
              <FontAwesome name="plus" />
            </PhotoContainer>
          </Col>
          <Col md={9} className="member-text">
            <span className="text-gray">Add new collaborator</span>
          </Col>
        </Row>

        <CreateMember
          open={this.state.openCreateModal}
          onClose={() => this.handleCloseModal()}
          onSave={(data) => this.handleCreateMember(data)}
          type={this.props.type}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  team: state.teams.selectedTeam,
  status: state.users.status,
  error: state.users.error,
});

const mapDispatchToProps = (dispatch) => ({
  addMember: (member) => {
    dispatch(actions.addTeamMember(member));
  },
  createMember: (member) => {
    dispatch(actions.createTeamMember(member));
  },
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NewMember);



// WEBPACK FOOTER //
// src/components/Members/NewMember.jsx